var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[(_vm.account == 'user')?_c('user-board',{attrs:{"user":_vm.auth}}):_vm._e(),(_vm.account == 'business')?_c('business-board',{attrs:{"business":_vm.business}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }